var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMrFamilyStepArrowTo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.3686,
    height: 79,
    viewBox: "0 0 15.3686 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M14.7834 36.4965C15.5637 38.4228 15.5637 40.5772 14.7834 42.5035L0 79L8.07576e-07 0L14.7834 36.4965Z",
    fill: "#F1F3F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrFamilyStepArrowTo3);
export default __webpack_public_path__ + "static/media/MrFamily_Step_Arrow_To3.06fb4cea1dd856c0c8b929309ec5a365.svg";
export { ForwardRef as ReactComponent };